<template>
    <div class="card-category-small">
        <img width="38" :src="category.image">
        <span>{{ category.label }}</span>
    </div>
</template>

<script>

export default {
    name: 'CategoryCardSmall',
    props: ['category'],
};

</script>
